import { z } from "zod/v4"

import { roleSchema } from "../roles"

export const userSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.email(),
  avatarUrl: z.url().nullable(),
  isEmailConfirmed: z.boolean(),
  createdAt: z.coerce.date(),
  role: roleSchema,
})

export type TUser = z.infer<typeof userSchema>
